import { Stack, Tag, TagCloseButton, TagLabel } from "@biblioteksentralen/react";
import { FilterOption } from "./useFilter";

interface Props {
  items: FilterOption[];
  onTagUpdate: (option: FilterOption) => void;
}

const FilterTags = (props: Props) => (
  <Stack
    direction="row"
    paddingBottom={props.items.length > 0 ? 4 : 0}
    gridGap={2}
    wrap="wrap"
    justifyContent="flex-start"
  >
    {props.items.map((item, index) => (
      <Tag size="md" key={index} borderRadius="full" variant="solid" bg="#000">
        <TagLabel>{item.value}</TagLabel>
        <TagCloseButton
          id={item.key}
          name={item.value}
          onClick={() => props.onTagUpdate(item)}
          opacity="1"
          _focus={{ border: ".15rem solid #fff" }}
        />
      </Tag>
    ))}
  </Stack>
);

export default FilterTags;
